import { computed as c, openBlock as a, createElementBlock as n, normalizeClass as s, Fragment as m, renderList as p, createElementVNode as v, withModifiers as g, toDisplayString as k } from "vue";
/* empty css                             */
const f = ["data-track-component-name", "data-track-text", "onClick"], C = /* @__PURE__ */ Object.assign({
  name: "DsOnPageNavigationList"
}, {
  __name: "on-page-navigation-list",
  props: {
    /**
     * List items
     * Each item should be an object: `{ label: String, slug: String, active: Boolean }`
     */
    items: {
      type: Array,
      required: !0
    },
    /**
     * Indicates if it should render the items with small text
     */
    smallText: {
      type: Boolean,
      default: !1
    },
    /**
     * List disposition
     * Possible values are: 'vertical', 'horizontal' or '' (empty).
     */
    disposition: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const o = t, l = c(() => o.disposition === "vertical"), e = c(() => o.disposition ? l.value ? "ds-button-navigation--tertiary" : "ds-button-navigation--secondary" : "");
    return (r, y) => (a(), n("ul", {
      class: s(["list", [t.disposition && `list--${t.disposition}`]])
    }, [
      (a(!0), n(m, null, p(t.items, ({ label: i, slug: d, active: u }) => (a(), n("li", {
        key: d,
        class: s(["list__item", { "ds-padding-12": !t.disposition }])
      }, [
        v("a", {
          href: "#",
          class: s(["ds-button-navigation", [
            { "ds-width-full": l.value },
            t.smallText && e.value ? `${e.value}-small` : e.value,
            { "ds-button-navigation--active": u && e.value }
          ]]),
          "data-track-component-name": r.$options.name,
          "data-track-text": i,
          "data-j-navigation-links": "",
          onClick: g((h) => r.$emit("clicked-item", { slug: d, label: i }), ["prevent"])
        }, k(i), 11, f)
      ], 2))), 128))
    ], 2));
  }
});
export {
  C as default
};
